import { createContext, ReactNode } from 'react';
import { QueryFunction } from '@tanstack/react-query';

export const AddQueryFnContext = createContext<AddQueryFnType>(() => undefined);

type AddQueryFnType = (
  key: string,
  queryFns: Record<string, QueryFunction>,
) => void;

export interface AppQueryFunctionsProviderProps {
  children: ReactNode;
}

export interface QueryFnContextProps {
  children: ReactNode;
}
